import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Remove Vehicles',
        defaultMessage: 'Remove Vehicles',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Vehicles',
        defaultMessage: 'Are you sure you want to remove this Vehicles from the list?',
    }
});